import { SupabaseClient } from '@supabase/supabase-js';
import React, { useState } from 'react';
import { Button, Container, Input, Text, Alert } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';

function UpdatePassword({
  supabaseClient,
}: {
  supabaseClient: SupabaseClient;
}) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const t = useTranslations('Auth.update_password');

  const handlePasswordReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    const { error } = await supabaseClient.auth.updateUser({ password });
    if (error) setError(error.message);
    else setMessage(t('confirmation_text'));
    setLoading(false);
  };

  return (
    <form id="auth-update-password" onSubmit={handlePasswordReset}>
      <Container gap="large">
        <Container gap="large">
          <div>
            <Text>{t('password_label')}</Text>
            <Input
              id="password"
              name="password"
              placeholder={t('password_label')}
              type="password"
              autoFocus
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPassword(e.target.value)
              }
            />
          </div>
          <Button type="submit" color="primary">
            {loading ? t('loading_button_label') : t('button_label')}
          </Button>
        </Container>
        {message && <Alert>{message}</Alert>}
        {error && <Alert color="danger">{error}</Alert>}
      </Container>
    </form>
  );
}

export { UpdatePassword };
